/**
 * Lightweight auth wrapper that verifies a valid Cognito session without onboarding or role logic.
 */
import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { getCurrentUser } from "aws-amplify/auth";


const RequireAuthenticated: React.FC = () => {
  const navigate = useNavigate();
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    let cancelled = false;

    getCurrentUser()
      .then(() => {
        if (!cancelled) setAuthenticated(true);
      })
      .catch(() => {
        if (!cancelled) navigate("/login", { replace: true });
      });

    return () => {
      cancelled = true;
    };
  }, [navigate]);

  if (!authenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F5F5F7]">
        <div className="text-sm text-slate-500">Checking session…</div>
      </div>
    );
  }

  return <Outlet />;
};

export default RequireAuthenticated;
